<template>
  <div v-if="survey && breadcrumbs && tab" id="scrollparent" ref="scrollparent">
    <!-- breadcrumbs -->
    <v-divider></v-divider>
      <v-layout ma-0 py-1 class="d-flex align-center justify-space-between">
        <span v-if="breadcrumbs" class="d-flex align-center justify-space-between">
          <v-icon size="15px" color="secondary">icon-directory</v-icon>
          <button
            v-if="breadcrumbs.sequence &&
                  tab.type === 'sequence' || tab.type === 'question'"
            :class="tab.type === 'question' ? 'link pa-2' : 'link pa-2 disabled'"
            @click="tab.type === 'question' ? changeTab({type: 'sequence', object: breadcrumbs.sequence}, true) : ''"
            v-html="breadcrumbs.sequence[`title_${$i18n.locale}`]"
          ></button>
          <span v-if="breadcrumbs.question && tab.type === 'question'"> - </span>
          <button
            v-if="tab.type === 'question'"
            class="link pa-2 disabled"
            v-html="breadcrumbs.question[`title_${$i18n.locale}`]"
          ></button>
        </span>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" text small @click="changeGrid">
              <v-icon color="primary">dashboard</v-icon>
            </v-btn>
          </template>
          <span>{{ $t("edit-audit-screen.change-view") }}</span>
        </v-tooltip>
      </v-layout>
    <v-divider></v-divider><!-- breadcrumbs -->

    <v-row wrap class="mt-5 mt-md-8">
      <!-- Navigate between sequences -->
      <v-col cols="12" md="5" order-md="2" v-scroll="onScroll" ref="sticky" class="sticky-nav">

        <SubmitAudit
          :answerid="$route.params.answerid"
          :survey="survey"
          :firm="firm"
          class="mb-5"></SubmitAudit>

          <div class="box">
            <v-layout
              d-block
              d-md-flex
              row
              ma-0
              align-center
              justify-space-between
              class="box-header px-5 px-md-6">
                <h3>{{ $t("edit-audit-screen.navigation-box-title") }}</h3>
            </v-layout>
            <div class="box-content flex px-6 px-md-8">
              <div v-for="sequence in survey.sequences"
                   :key="sequence.id"
                   class="flex row align-center justify-space-between">
                <span class="row ma-0 mb-4 mb-md-0 pa-0">
                  <v-icon
                    size="15px"
                    class="col-1 mr-2"
                    color="secondary">icon-directory</v-icon>
                  <button
                    class="subtitle-1 link pa-0 pa-md-2 mb-1 col-10 text-left"
                    @click="changeTab({type: 'sequence', object: sequence}, true)"
                    v-html="sequence[`title_${$i18n.locale}`]"
                  ></button>
                </span>
              </div>
            </div>
          </div>
      </v-col>

      <v-col cols="12" md="7" ref="ancre">
        <template v-if="tab">
          <template v-if="tab.type === 'sequence' && renderComponent">
            <SequenceBox
              :answerid="$route.params.answerid"
              :sequence="tab.object"
              @tabChnage="changeTab"
            ></SequenceBox>
          </template>

          <template v-if="tab.type === 'question' && renderComponent">
            <QuestionBox
              :answerid="$route.params.answerid"
              :question="tab.object"
              :maxDerogations="parseInt(survey.total.maxderogations)"
              :doneDerogations="parseInt(survey.done.maxderogations)"
              :disabledInputs="survey.info.status === 'sent' ? true : false"
              @tabChnage="changeTab"
              @updateSubmitBtn="refreshSubmitBtn"
            ></QuestionBox>
            <!-- <pre>{{tab.object}}</pre> -->
          </template>
        </template>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import SequenceBox from '@/components/audits/survey/SequenceBox'
import QuestionBox from '@/components/audits/survey/QuestionBox'
import SubmitAudit from '@/components/audits/SubmitAudit'

export default {
  props: {
    survey: Array | Object,
    firm: Array | Object,
    createdBreadcrumbs: Array | Object,
    createdTab: Array | Object
  },

  components: {
    SequenceBox: SequenceBox,
    QuestionBox: QuestionBox,
    SubmitAudit: SubmitAudit
  },

  data () {
    return {
      breadcrumbs: this.createdBreadcrumbs ? this.createdBreadcrumbs : { sequence: null, question: null },
      tab: this.createdTab ? this.createdTab : { type: 'sequence', object: null },
      renderComponent: true
    }
  },

  created () {
    if (this.$route.params.tab) {
      this.breadcrumbs.question = this.$route.params.tab
      this.breadcrumbs.sequence = this.createdBreadcrumbs.sequence
    }
  },

  methods: {
    changeTab (value, force) {
      // change tab value
      this.tab = value
      // change breadcrumbs value
      if (value.type === 'sequence') {
        this.breadcrumbs.sequence = value.object
      } else if (value.type === 'question') {
        this.breadcrumbs.question = value.object
      }
      if (force) this.forceRerender()

      this.$vuetify.goTo('#scrollparent')
    },
    forceRerender() {
      // Remove my-component from the DOM
      this.renderComponent = false
      
      this.$nextTick(() => {
        // Add the component back in
        this.renderComponent = true
        // this.$vuetify.goTo('scrollparent')
      })
    },

    changeGrid () {
      this.$emit('changeGridViews')
      // TODO: scroll when
      // changeTab({type: 'sequence', object: breadcrumbs.sequence}, true)
    },

    onScroll () {
      if (this.$vuetify.breakpoint.name === 'xs' ||
          this.$vuetify.breakpoint.name === 'sm') {

        this.$refs.sticky.style.transform = 'translateY(0px)'
        return
      }
      // this.offsetTop = e.target.scrollTop
      const sticky = this.$refs.sticky
      const offsetTop = window.pageYOffset || document.documentElement.scrollTop

      if (offsetTop > sticky.offsetTop) {
        // console.log(this.$refs.scrollparent.offsetTop)
        if (((offsetTop - sticky.offsetTop - 100) + sticky.offsetHeight) >= (this.$refs.scrollparent.offsetHeight - 100)) return
        // (offsetTop - sticky.offsetTop - 100) + 
        sticky.style.transform = `translateY(${offsetTop - sticky.offsetTop - 100}px)`
      }
      else {
        sticky.style.transform = 'translateY(0px)'
      }
    },

    refreshSubmitBtn () {
      this.$emit('reloadSubmitBtn')
    },
  }
}
</script>
